var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"months-container mt-2"},_vm._l((_vm.months),function(month,index){return _c('li',{key:index,class:[{ selected: month === _vm.selectedMonth }, 'month'],on:{"click":function($event){return _vm.selectMonth(index)}}},[_vm._v(" "+_vm._s(month)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }